module.exports = __webpack_public_path__ + "img/dj.af9ae86b.jpg";